import { TListPublishedMasterProductsResDto } from "@/api/services/main/master-product/dtos/list-published-master-products.dto";
import { QUERY_KEYS } from "@/constants/queryKeys";
import { clientApi } from "@/utils/api";
import { useQuery } from "@tanstack/react-query";

export const fetchPublishedMasterProductsApi = async (): Promise<TListPublishedMasterProductsResDto> => {
  const { data } = await clientApi.get<TListPublishedMasterProductsResDto>("/master-products");
  return data;
};

export const usePublishedMasterProducts = () => {
  const { data, ...rest } = useQuery({
    queryKey: [QUERY_KEYS.MASTER_PRODUCT.FETCH_LIST],
    queryFn: () => fetchPublishedMasterProductsApi(),
  });

  return { data: data?.data ?? [], ...rest };
};
